import { format, parseISO } from "date-fns";

import { createCareplanSubscriptionProductDataModel } from "@/domains/careplan/factories/create-careplan-subscription-product-data-model";
import type { SubscriptionResponse } from "@/domains/careplan/models/types";

export const createCareplanSubscriptionDataModel = (subscription: SubscriptionResponse) => {
  return {
    ...subscription,
    nextBillingDate: subscription.nextBillingDate
      ? format(parseISO(subscription.nextBillingDate), "MMMM d, y")
      : null,
    products: subscription.products.map(createCareplanSubscriptionProductDataModel),
  };
};
